export default __webpack_public_path__ + "static/the_marketer-d87fc64bd648e347892341e319510388.svg";